var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#FFBD5C",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6667 10.6667H14.3334L12.6667 12.6667H10.6667C10.3131 12.6667 9.97395 12.8072 9.7239 13.0572C9.47385 13.3073 9.33337 13.6464 9.33337 14V20C9.33337 20.3536 9.47385 20.6928 9.7239 20.9428C9.97395 21.1929 10.3131 21.3334 10.6667 21.3334H21.3334C21.687 21.3334 22.0261 21.1929 22.2762 20.9428C22.5262 20.6928 22.6667 20.3536 22.6667 20V14C22.6667 13.6464 22.5262 13.3073 22.2762 13.0572C22.0261 12.8072 21.687 12.6667 21.3334 12.6667H19.3334L17.6667 10.6667Z",
    stroke: "#FFBD5C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.6667C17.1046 18.6667 18 17.7713 18 16.6667C18 15.5621 17.1046 14.6667 16 14.6667C14.8954 14.6667 14 15.5621 14 16.6667C14 17.7713 14.8954 18.6667 16 18.6667Z",
    stroke: "#FFBD5C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/Photo.d4505a979e68f26a371ac8418aa571eb.svg";
export { ForwardRef as ReactComponent };